const base = "/permisos-sindicales";
const paths = {
  show: "/licenses",
  licenses_by_business_partner: base.concat("/licenses-by-business-partner"),
  reverseRetraction: base.concat("/licenses-by-business-partner"),
};

export { paths, base };
